import { useCallback } from "react";
import BackGroundService from "../../../services/background";

export const useTaskStatus = (
  onError: (val: string) => void,
  onSuccess: () => void,
) => {
  const getStatus = useCallback(
    async (id: string) => {
      try {
        const res = await BackGroundService.getProgress(id);

        const { status, result } = res;

        if ([6, 4].includes(status)) {
          if (status === 4) {
            result.status === 1 ? onSuccess() : onError(result.errorMessage);
          } else {
            onError("Payment failed");
          }
        } else {
          setTimeout(async () => {
            await getStatus(id);
          }, 1000);
        }
      } catch (e: any) {
        onError(e.response.data.title);
      }
    },
    [onSuccess, onError],
  );

  return { getStatus };
};
